<template>
  <div class="app-router">
    <modalAddAddress ref="modalAddAddress" @action="saveAddress"></modalAddAddress>
    <modalSelectAddress ref="modalAddress" @action="selectAddress"></modalSelectAddress>

    <div ref="top" class="d-flex flex-row align-center pb-5">
      <v-btn class="mr-4" small fab elevation="0" @click="backToList">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <template v-if="!isMobile">
        <h2 class="font-weight-bold d-flex flex-column">
          Form Pembelian Produk Reseller
          <span class="text-caption">Pemesanan produk khusus Reseller.</span>
        </h2>
      </template>

      <template v-else>
        <div class="text-subtitle-1 font-weight-bold d-flex flex-column">
          Form Pembelian Produk Reseller
          <span
            class="text-caption"
          >Pemesanan produk khusus Reseller .</span>
        </div>
      </template>
    </div>

    <v-layout v-resize="onResize" column>
      <v-card outlined elevation="0" id="filter-card" class="mt-0">
        <v-card-title
          class="font-weight-bold"
          :class="isMobile ? 'text-subtitle-2' : 'text-subtitle-1'"
        >
          <v-row justify="space-between" class="mx-3">
            Tambah Pemesanan
            <v-badge
              :value="pembelian.items.length !== 0"
              color="green"
              overlap
              :content="pembelian.items.length || 0"
            >
              <v-btn color="black" class="white--text" ref="cart" @click="cartModalCheckOngkir">
                <v-icon>mdi-cart</v-icon>
              </v-btn>
            </v-badge>
          </v-row>
        </v-card-title>
        <!-- <hr />
        shippingOption: {{shippingOption}}
        <hr />
        selectedAddress: {{selectedAddress}}-->
        <v-card-text>
          <search-dialog
            class="mb-4"
            v-model="produkForm.supplier"
            @change="getProduct"
            :listData="listSupplier"
          />
          <template v-if="listProduk.length > 0 && produkForm.supplier.product_supplier_id!=''">
            <v-card v-if="loadingProduct">
              <v-row>
                <v-col class="text-center">
                  <v-progress-circular indeterminate color="green"></v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
            <template v-else>
              <card-list
                :listData="listProduk"
                v-if="listProduk.length"
                @showConfirmAdd="showConfirmAdd"
              />
            </template>
          </template>
          <template v-else>
            <v-card>
              <v-card-text class="text-center">Data Tidak Tersedia</v-card-text>
            </v-card>
          </template>
        </v-card-text>

        <v-card-text>
          <!-- halooo:
          <br />
          {{ resellerTypeValue }}
          {{ pembelian.items }}-->
        </v-card-text>
      </v-card>
    </v-layout>

    <v-dialog v-model="dialogAddProduct" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">Tambahkan Produk</v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <v-alert
            dense
            color="warning"
            outlined
            class="white--text mb-5 orange lighten-5"
            v-if="existProduct"
          >
            <div class="text-subtitle-2">
              Produk
              <span class="black--text px-2">
                {{ produkForm.product.product_code }} -
                {{ produkForm.product.product_name }}
              </span>
              sudah ada di dalam daftar belanja. Anda dapat mengubah jumlah
              belanja dari produk ini.
            </div>
          </v-alert>

          <v-alert
            dense
            color="error"
            outlined
            class="white--text mb-5 orange lighten-5"
            v-if="notSameSupplier"
          >
            <div class="text-subtitle-2">
              Mohon maaf, tidak diizinkan melakukan pemesanan produk dengan
              Supplier yang berbeda.
            </div>
          </v-alert>

          <v-form ref="formAddProduk" role="form">
            <v-row>
              <v-col cols="12" sm="3" :class="{ 'py-0': isMobile }">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">Pilih Supplier</div>
              </v-col>
              <v-col cols="12" sm="9">
                <v-autocomplete
                  v-model="produkForm.supplier"
                  :items="listSupplier"
                  return-object
                  placeholder="Pilih Supplier"
                  item-text="product_supplier_name"
                  item-value="product_supplier_id"
                  hide-details="auto"
                  outlined
                  dense
                  @change="getProduct"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="produkForm.supplier != ''">
              <v-col cols="12" sm="3" :class="{ 'py-0': isMobile }">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">Pilih Produk</div>
              </v-col>
              <v-col cols="12" sm="9">
                <!-- item-text="product_name"  -->

                <v-autocomplete
                  v-model="produkForm.product"
                  :items="listProduk"
                  return-object
                  placeholder="Pilih Produk"
                  :item-text="
                    (item) => `${item.product_code} - ${item.product_name}`
                  "
                  item-value="product_id"
                  hide-details="auto"
                  outlined
                  dense
                  @change="cekExistingProduct"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" :class="{ 'py-0': isMobile }">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">Berat Produk</div>
              </v-col>
              <v-col cols="12" sm="9">
                <span
                  class="font-weight-bold text-subtitle-1 green--text"
                  v-if="produkForm.product"
                >{{ produkForm.product.product_weight | toKg }}</span>
                <span class="font-weight-normal text-subtitle-1 grey--text" v-else>0 gr</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" :class="{ 'py-0': isMobile }">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">Harga Produk</div>
              </v-col>
              <v-col cols="12" sm="9">
                <span class="font-weight-bold text-subtitle-1 green--text">
                  {{
                  produkForm.product.product_price | toRupiah
                  }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" :class="{ 'py-0': isMobile }">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">Jumlah Pembelian</div>
              </v-col>
              <v-col cols="12" sm="5">
                <div class="d-flex align-center">
                  <div class="d-inline px-0 py-0 mx-3 font-weight-bold">
                    <v-text-field
                      v-model="produkForm.product_qty"
                      single-line
                      small
                      class="text-body-1 input-center"
                      :height="45"
                      :width="200"
                      dense
                      placeholder="jumlah"
                      @keypress="onlyNumber"
                      :rules="qtyRules"
                      hide-details="auto"
                    >
                      <template slot="prepend-inner">
                        <v-btn
                          x-small
                          color="red"
                          class="white--text mr-2"
                          outlined
                          height="35"
                          :disabled="produkForm.product_qty < 2"
                          @click="produkForm.product_qty--"
                        >
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </template>
                      <template slot="append">
                        <v-btn
                          x-small
                          color="primary"
                          outlined
                          height="35"
                          @click="produkForm.product_qty++"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions :class="isMobile ? 'px-5 mx-5' : 'mt-5'">
          <v-spacer v-if="!isMobile"></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              :loading="loadingProcess"
              @click="clearFormProduk"
              class="my-2 px-5 text-capitalize"
              v-if="!isMobile"
            >Batal</v-btn>
            <v-btn
              color="black"
              :loading="loadingProcess"
              @click="addToCart"
              class="my-2 px-5 text-capitalize white--text"
              :class="isMobile ? 'v-btn--block' : 'ml-2'"
              :disabled="produkForm.product === ''"
            >Simpan</v-btn>
            <v-btn
              outlined
              :loading="loadingProcess"
              @click="clearFormProduk"
              class="my-2 px-5 text-capitalize"
              :class="isMobile ? 'v-btn--block' : ''"
              v-if="isMobile"
            >Batal</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCart" persistent max-width="1200" scrollable>
      <v-card>
        <v-card-title
          class="font-weight-bold"
          :class="isMobile ? 'text-subtitle-2' : 'text-subtitle-1'"
        >
          <v-row justify="space-between" class="mx-3">Cart</v-row>
        </v-card-title>
        <hr />
        <v-card-text>
          <v-form ref="formPO" role="form">
            <v-card outlined elevation="0" class="mb-5 mt-5">
              <v-card-text class="pa-0">
                <!-- {{dataSupplier}} -->
                <v-simple-table>
                  <thead>
                    <tr v-show="false">
                      <th style="width: 20%">Supplier</th>
                      <th>
                        <br />
                        <v-img
                          :title="dataSupplier.product_supplier_name"
                          v-if="dataSupplier.product_supplier_image != ''"
                          width="80"
                          max-width="80"
                          class="mr-4"
                          :src="
                            dataSupplier.product_supplier_image != ''
                              ? dataSupplier.product_supplier_image
                              : '/assets/product/default.png'
                          "
                        ></v-img>
                        <span v-else>
                          <b>{{ dataSupplier.product_supplier_name }}</b>
                        </span>
                      </th>
                    </tr>
                    <tr v-show="false">
                      <th>Minimal Transaksi</th>
                      <th>
                        {{
                        dataSupplier.product_supplier_transaction_minimum
                        | toRupiah
                        }}
                      </th>
                    </tr>
                    <tr>
                      <th>Tipe Reseller</th>
                      <th>{{ resellerTypeValue | uppercase }}</th>
                    </tr>
                    <tr v-show="false">
                      <th style="width: 20%">Saldo Coin Gen</th>
                      <th>{{ saldoCoinGen | toRupiah }}</th>
                    </tr>
                    <tr>
                      <th style="width: 20%">Saldo Deposit Reseller</th>
                      <th>{{ saldoDepositReseller | toRupiah }}</th>
                    </tr>
                  </thead>
                </v-simple-table>
                <v-simple-table>
                  <thead>
                    <tr
                      :class="{
                        'd-none': isMobile && dataBeli.items.length === 0,
                      }"
                      v-if="!isMobile"
                    >
                      <th class="text-left" width="40%">Nama Produk</th>
                      <th class="text-right" width="15%">Harga</th>
                      <th class="text-center" width="25%">Jumlah</th>
                      <th class="text-right">Subtotal</th>
                      <th class="text-right" width="5%"></th>
                    </tr>

                    <tr
                      :class="{
                        'd-none': isMobile && dataBeli.items.length === 0,
                      }"
                      v-else
                    >
                      <th class="text-left">Info Produk</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loading">
                    <template v-if="dataBeli.items.length > 0">
                      <template v-for="(produk, idx) in dataBeli.items">
                        <tr :key="idx" v-if="!isMobile">
                          <td class="text-left">
                            <div class="d-flex flex-row align-center py-3">
                              <v-img
                                width="80"
                                max-width="80"
                                class="mr-4"
                                :src="
                                  produk.product.product_image[0]
                                    ? produk.product.product_image[0]
                                    : '/assets/product/default.png'
                                "
                              ></v-img>
                              <div class="d-flex flex-column">
                                <!-- <router-link :to="'/product/'" class="font-weight-bold no-line">{{
                                produk.product.product_name }}</router-link>-->
                                <span class="font-weight-bold no-line">
                                  {{ produk.product.product_code }} -
                                  {{ produk.product.product_name }}
                                </span>
                                <span class="text-caption">
                                  berat item :
                                  {{ produk.product.product_weight | toKg }}
                                  <small
                                    v-if="produk.product.product_length && produk.product.product_width && produk.product.product_height"
                                  >
                                    <br />
                                    Volume: {{produk.product.product_length}} x {{produk.product.product_width}} x {{produk.product.product_height}}
                                  </small>
                                </span>
                                <span class="text-caption">
                                  jumlah berat item :
                                  <strong>
                                    {{
                                    produk.product_weight_subtot | toKg
                                    }}
                                  </strong>
                                </span>
                                <span class="text-caption">
                                  Supplier :
                                  <strong>
                                    {{
                                    produk.product_supplier_name | uppercase
                                    }}
                                  </strong>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-right">
                            <strong>
                              {{
                              produk.product.product_price | toRupiah
                              }}
                            </strong>
                            <template v-if="produk.product.discount_value > 0">
                              <br />
                              <span style="color: red; font-size: 10px">
                                {{ produk.product.discount_percent }}%
                                <strike>
                                  {{
                                  produk.product.product_price_gross
                                  | toRupiah
                                  }}
                                </strike>
                              </span>
                            </template>
                          </td>
                          <td class="text-center">
                            <div class="d-flex align-center">
                              <v-text-field
                                v-model="produk.product_qty"
                                single-line
                                small
                                class="text-body-1 input-center"
                                :height="45"
                                :width="200"
                                dense
                                placeholder="jumlah"
                                @keypress="onlyNumber"
                                @input="changeQty(produk)"
                                :rules="qtyRules"
                                hide-details="auto"
                              >
                                <template slot="prepend-inner">
                                  <v-btn
                                    text
                                    x-small
                                    color="red"
                                    height="35"
                                    :disabled="produk.product_qty < 2"
                                    @click="minsQty(produk)"
                                  >
                                    <v-icon>mdi-minus-circle</v-icon>
                                  </v-btn>
                                </template>
                                <template slot="append">
                                  <v-btn
                                    text
                                    x-small
                                    color="primary"
                                    height="35"
                                    @click="addQty(produk)"
                                  >
                                    <v-icon>mdi-plus-circle</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </div>
                          </td>
                          <td class="text-right" width="23%">
                            <strong class="green--text">
                              {{
                              produk.product_subtot | toRupiah
                              }}
                            </strong>
                          </td>
                          <td class="text-right">
                            <v-btn
                              color="error"
                              dark
                              outlined
                              min-width="auto"
                              class="pa-2"
                              width="36"
                              height="36"
                              @click="removeItem(idx)"
                            >
                              <span class="text-subtitle-2 text-capitalize font-weight-bold">
                                <v-icon center>mdi-delete</v-icon>
                              </span>
                            </v-btn>
                          </td>
                        </tr>

                        <tr :key="idx" v-else>
                          <td class="text-left">
                            <div class="d-flex flex-row align-center justify-end pt-2 mb-3">
                              <v-btn
                                color="error"
                                dark
                                outlined
                                min-width="auto"
                                class="pa-2"
                                width="36"
                                height="36"
                                @click="removeItem(idx)"
                              >
                                <span class="text-subtitle-2 text-capitalize font-weight-bold">
                                  <v-icon center>mdi-delete</v-icon>
                                </span>
                              </v-btn>
                            </div>
                            <v-divider></v-divider>
                            <div class="d-flex flex-row align-center py-2">
                              <v-img
                                width="80"
                                max-width="80"
                                class="mr-4"
                                :src="
                                  produk.product.product_image[0]
                                    ? produk.product.product_image[0]
                                    : '/assets/product/default.png'
                                "
                              ></v-img>
                              <div class="d-flex flex-column">
                                <!-- <router-link :to="'/product/'" class="font-weight-bold no-line">{{
                                produk.product.product_name }}</router-link>-->
                                <span class="font-weight-bold no-line">
                                  {{
                                  produk.product.product_name
                                  }}
                                </span>
                                <span class="text-caption">
                                  berat item :
                                  {{ produk.product.product_weight | toKg }}
                                </span>
                                <span class="text-caption">
                                  jumlah berat :
                                  <strong>
                                    {{
                                    produk.product_weight_subtot | toKg
                                    }}
                                  </strong>
                                </span>
                              </div>
                            </div>

                            <v-row>
                              <v-col cols="4">
                                <div class="text-caption d-inline-block">Harga</div>
                              </v-col>
                              <v-col cols="8" class="text-right">
                                <strong>
                                  {{
                                  produk.product.product_price | toRupiah
                                  }}
                                </strong>
                                <template v-if="produk.product.discount_value > 0">
                                  <br />
                                  <span style="color: red; font-size: 10px">
                                    {{ produk.product.discount_percent }}%
                                    <strike>
                                      {{
                                      produk.product.product_price_gross
                                      | toRupiah
                                      }}
                                    </strike>
                                  </span>
                                </template>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="4">
                                <div class="text-caption d-inline-block pr-5">Jumlah</div>
                              </v-col>
                              <v-col cols="8" class="pt-0 text-right">
                                <div class="d-flex align-center">
                                  <v-text-field
                                    v-model="produk.product_qty"
                                    single-line
                                    small
                                    class="text-body-1 input-center"
                                    :height="45"
                                    :width="200"
                                    dense
                                    placeholder="jumlah"
                                    @keypress="onlyNumber"
                                    @input="changeQty(produk)"
                                    :rules="qtyRules"
                                    hide-details="auto"
                                  >
                                    <template slot="prepend-inner">
                                      <v-btn
                                        text
                                        x-small
                                        color="red"
                                        height="35"
                                        class="pl-0"
                                        :disabled="produk.product_qty < 2"
                                        @click="minsQty(produk)"
                                      >
                                        <v-icon>mdi-minus-circle</v-icon>
                                      </v-btn>
                                    </template>
                                    <template slot="append">
                                      <v-btn
                                        text
                                        x-small
                                        color="primary"
                                        height="35"
                                        class="pr-0"
                                        @click="addQty(produk)"
                                      >
                                        <v-icon>mdi-plus-circle</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="4">
                                <div class="text-caption d-inline-block pr-5">Subtotal</div>
                              </v-col>
                              <v-col cols="8" class="text-right">
                                <strong class="green--text">
                                  {{
                                  produk.product_subtot | toRupiah
                                  }}
                                </strong>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </template>
                    </template>

                    <template v-else>
                      <tr>
                        <td :colspan="isMobile ? 1 : 5">
                          <div
                            class="d-flex flex-column align-center py-5 px-5"
                            :class="{ 'text-center': isMobile }"
                          >
                            <v-img
                              width="100"
                              class="py-5 my-4"
                              src="/assets/seller/belum-ada-pesanan.svg"
                            ></v-img>
                            <div
                              class="text-subtitle-1 black--text font-weight-bold"
                            >Belum ada data pembelian produk</div>
                            <p class="black--text darken-5">
                              Silakan klik tombol
                              <strong>Tambah Produk</strong>
                              untuk memasukkan item pembelian anda.
                            </p>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>

                  <tbody v-else>
                    <tr>
                      <td :colspan="isMobile ? 1 : 5">
                        <div class="d-block text-center pa-4 text-caption">Loading...</div>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr v-if="dataBeli.items.length > 0">
                      <td :colspan="isMobile ? 1 : 5" class="pa-0 py-0" style="height: auto">
                        <hr />
                      </td>
                    </tr>
                    <tr v-if="dataBeli.items.length > 0">
                      <template v-if="!isMobile">
                        <td colspan="3" class="py-0 text-right">
                          <span
                            class="mr-4 text-subtitle-2 black--text font-weight-bold"
                          >Total Berat Item</span>
                        </td>
                        <td class="py-0 pl-0">
                          <div class="d-flex flex-row align-center justify-end">
                            <span
                              class="font-weight-bold red--text text-subtitle-2"
                            >{{ grandWeightTotal | toKg }}</span>
                          </div>
                        </td>
                        <td></td>
                      </template>

                      <template v-else>
                        <td>
                          <v-row>
                            <v-col cols="6">
                              <span
                                class="text-subtitle-2 black--text font-weight-bold"
                              >Total Berat Item</span>
                            </v-col>
                            <v-col cols="6">
                              <div class="d-flex flex-row align-center justify-end">
                                <span
                                  class="font-weight-bold red--text text-subtitle-2"
                                >{{ grandWeightTotal | toKg }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </td>
                      </template>
                    </tr>
                    <tr>
                      <td :colspan="isMobile ? 1 : 5" class="pa-0 py-0" style="height: auto">
                        <hr class="ma-0" />
                      </td>
                    </tr>
                    <tr v-if="dataBeli.items.length > 0">
                      <template v-if="!isMobile">
                        <td colspan="3" class="py-0 text-right">
                          <span
                            class="mr-4 text-subtitle-1 black--text font-weight-bold"
                          >Total Pembelian</span>
                        </td>
                        <td class="py-0 pl-0">
                          <div class="d-flex flex-row align-center justify-end">
                            <span
                              class="font-weight-bold green--text text-subtitle-1"
                            >{{ grandTotal | toRupiah }}</span>
                          </div>
                        </td>
                        <td></td>
                      </template>

                      <template v-else>
                        <td>
                          <v-row>
                            <v-col cols="12" class="text-right pb-0">
                              <span
                                class="d-block text-subtitle-1 black--text font-weight-bold text-right"
                              >Total Pembelian</span>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                              <div class="d-flex flex-row align-center justify-end">
                                <span
                                  class="font-weight-bold green--text text-h6"
                                >{{ grandTotal | toRupiah }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </td>
                      </template>
                    </tr>
                    <!-- <tr v-if="!isMobile">
                      <td :colspan="isMobile ? 1 : 5" class="pa-0 py-0">
                        <hr />
                        <div class="pa-4">
                          <v-btn color="success" dark outlined @click="dialogAddProduct = true; notSameSupplier = false;">
                            <span class="text-subtitle-2 text-capitalize font-weight-bold">
                              <v-icon left>mdi-plus</v-icon>Tambah Produk
                            </span>
                          </v-btn>
                        </div>
                      </td>
                    </tr>-->
                  </tfoot>
                </v-simple-table>

                <div class="d-block pa-4" v-if="isMobile">
                  <v-btn
                    color="success"
                    dark
                    outlined
                    block
                    @click="
                      dialogAddProduct = true;
                      notSameSupplier = false;
                    "
                  >
                    <span class="text-subtitle-2 text-capitalize font-weight-bold">
                      <v-icon left>mdi-plus</v-icon>Tambah Produk
                    </span>
                  </v-btn>
                </div>
              </v-card-text>
              <v-card-text class="pa-0">
                <v-col class="py-0">
                  <v-row class="justify-space-between">
                    <v-col class="text-body-2 black--text my-auto">
                      <v-icon class="mt-n1" color="#272727">mdi-map-marker</v-icon>
                      <span class="pl-3 font-weight-bold black--text">Alamat Pengiriman</span>
                    </v-col>
                    <v-col
                      cols="3"
                      md="4"
                      class="text-right text-body-2"
                      v-if="selectedAddress != null"
                    >
                      <v-btn
                        outlined
                        color="#272727"
                        class="rounded-lg"
                        @click="openModalAddAddress"
                      >
                        <v-icon color="black">mdi-plus</v-icon>
                        <span
                          class="pl-2 text-body-2 font-weight-bold text-capitalize d-none d-md-inline"
                        >Tambah Alamat</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row v-if="selectedAddress">
                    <v-col cols="12" sm="3" md="3" class="pt-0">
                      <div>
                        <div class="text-subtitle-2 grey--text text--darken-1">Nama Penerima</div>
                        <div
                          class="text-body-1 font-weight-bold"
                        >{{selectedAddress.user_address_receipt_name}}</div>
                      </div>
                      <div class="pt-3 pt-sm-4">
                        <div class="text-subtitle-2 grey--text text--darken-1">Nomor Handphone</div>
                        <div
                          class="text-body-1 font-weight-bold"
                        >{{selectedAddress.user_address_mobilephone}}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="7" class="pl-sm-0 pt-0">
                      <div>
                        <div class="text-subtitle-2 grey--text text--darken-1">Alamat</div>
                        <div class="text-body-1">{{addressText(selectedAddress)}}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="3" md="2" class="pt-md-0 mt-md-n1 d-flex justify-center">
                      <v-btn
                        text
                        color="grey darken-2"
                        class="font-weight-bold text-capitalize"
                        v-if="selectedAddress.user_address_is_used == 'used'"
                      >Utama</v-btn>
                      <v-btn
                        text
                        color="indigo"
                        class="font-weight-bold text-capitalize"
                        @click="openModalAddress"
                      >Ubah</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" sm="6" md="6" class="pt-0">
                      <div class="d-flex">
                        <div class="pl-5">
                          <img width="100" src="/assets/icons/ilus-tidak-ada-alamat.svg" />
                        </div>
                        <div class="pl-3 text-body-2 my-auto">Opps alamat pengiriman belum ada...</div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pt-0 text-right my-auto">
                      <v-btn
                        x-medium
                        depressed
                        color="#272727"
                        class="font-weight-bold rounded-lg text-body-2 white--text"
                        @click="openModalAddAddress"
                      >
                        <v-icon>mdi-plus-circle</v-icon>
                        <span class="pl-3">Tambah Alamat</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card-text>
            </v-card>

            <template v-if="pembelian.items.length > 0">
              <v-row>
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">
                    Opsi Pengiriman
                    <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
                  </div>
                </v-col>
                <v-col cols="12" sm="8">
                  <!-- pembelian.courier_code: {{pembelian.courier_code}}
                  <br />
                  pembelian.shippingSelected: {{pembelian.shippingSelected}}-->
                  <div
                    v-show="
                      dropship.is_dropship_marketplace == false ? true : false
                    "
                  >
                    <v-autocomplete
                      v-model="pembelian.courier_code"
                      :items="shippingOption"
                      return-object
                      placeholder="Pilih kurir pengiriman"
                      hide-details="auto"
                      item-value="code"
                      outlined
                      dense
                      :rules="courierCodeRules"
                      :loading="loadingProcess"
                      @change="changeCourier"
                    >
                      <template v-slot:selection="data">
                        <div class="text-subtitle-2">
                          <strong>{{ data.item.name }}</strong>
                          - {{ data.item.service }}
                        </div>
                      </template>

                      <template v-slot:item="data">
                        <div class="d-flex flex-row align-center justify-space-between py-2">
                          <v-img
                            v-if="data.item.code !== 'pickup'"
                            width="50"
                            max-width="50"
                            class="mr-5"
                            :src="'/assets/courier/' + data.item.id + '.svg'"
                          ></v-img>
                          <v-img
                            v-else
                            width="45"
                            max-width="45"
                            class="mr-5"
                            src="/assets/icons/market-icon.svg"
                          ></v-img>
                          <div class="d-flex flex-column px-3 text-subtitle-2" style="width: 200px">
                            <strong>{{ data.item.name }}</strong>
                          </div>
                          <div class="d-flex flex-column px-2 text-caption ml-auto">
                            <div class="font-weight-bold">
                              {{ data.item.service }}
                              <span
                                v-if="data.item.etd"
                              >({{ data.item.etd }})</span>
                            </div>
                            {{ data.item.cost | toRupiah }}
                          </div>
                        </div>
                      </template>
                    </v-autocomplete>
                    <!-- pembelian.insurance_status: {{pembelian.insurance_status}} -->
                    <v-checkbox
                      v-show="(pembelian.courier_code!='' && pembelian.courier_code!='pickup' && pembelian.courier_group!='instant')?true:false"
                      @click.prevent="calculateInsurance(false)"
                      v-model="pembelian.insurance_status"
                      label="Asuransi"
                    ></v-checkbox>
                  </div>

                  <div class="d-flex justify-end py-4 font-weight-bold black--text">
                    <v-checkbox
                      @click.prevent="getListCourier"
                      v-model="dropship.is_dropship"
                      label="Dropship"
                    ></v-checkbox>
                  </div>
                  <div v-show="dropship.is_dropship == true">
                    <v-text-field v-model="dropship.dropship_store_name" label="Nama Pengirim"></v-text-field>
                    <v-text-field v-model="dropship.dropship_store_phone" label="Nomor Telepon"></v-text-field>
                    <div class="d-flex font-weight-bold black--text">
                      <v-checkbox
                        @click.prevent="recalculateShipping"
                        v-model="dropship.is_dropship_marketplace"
                        label="Dropship Marketplace"
                      ></v-checkbox>
                    </div>
                  </div>
                  <div
                    v-show="
                      dropship.is_dropship == true &&
                      dropship.is_dropship_marketplace == true
                    "
                  >
                    <v-autocomplete
                      v-model="dropship.dropship_marketplace_name"
                      :items="listCourierMarketplace"
                      return-object
                      placeholder="Pilih Marketplace"
                      hide-details="auto"
                      item-value="courier_code"
                      :loading="loadingProcess"
                      @change="recalculateShipping"
                      outlined
                      dense
                    >
                      <template v-slot:selection="data">
                        <div class="text-subtitle-2">
                          <strong>{{ data.item.courier_name }}</strong>
                        </div>
                      </template>
                      <template v-slot:item="data">
                        <div class="d-flex flex-row align-center justify-space-between py-2">
                          <div class="d-flex flex-column px-3 text-subtitle-2">
                            <strong>{{ data.item.courier_name }}</strong>
                          </div>
                        </div>
                      </template>
                    </v-autocomplete>
                    <v-text-field
                      v-model="dropship.dropship_marketplace_invoice"
                      label="Nomor Invoice Marketplace"
                    ></v-text-field>
                    <v-text-field v-model="dropship.dropship_marketplace_resi" label="Nomor Resi"></v-text-field>
                    <!-- <v-file-input v-model="dropship.dropship_marketplace_file_shipping_label"
                    label="File Shipping Label"></v-file-input>-->
                    <!-- {{ imgUpload }} -->
                    <div
                      v-if="
                        dropship.dropship_marketplace_file_shipping_label != ''
                      "
                    >
                      <a
                        :href="
                          dropship.dropship_marketplace_file_shipping_label
                        "
                        target="_blank"
                      >File Shipping</a>
                    </div>
                    <v-file-input
                      v-show="false"
                      accept="application/pdf"
                      id="inputImage"
                      v-model="imgUpload"
                      @change="handleFileUpload($event)"
                      truncate-length="50"
                      small-chips
                      outlined
                      dense
                      hide-details="auto"
                      prepend-icon
                      :clearable="false"
                      placeholder="Upload File"
                      class="mt-md-3 text-body-2 rounded-lg file-button"
                    ></v-file-input>
                    <v-btn
                      outlined
                      color="#272727"
                      class="px-0 mt-3 text-body-2 rounded-lg"
                      block
                      :loading="loadingProcess"
                      @click="openUpload"
                    >Upload File Shipping Label</v-btn>
                    <small>File PDF maksimal 2MB</small>
                  </div>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" sm="8" :class="{ 'py-0': isMobile }">
                </v-col>
                <v-col cols="12" sm="4">


                </v-col>
              </v-row>-->
              <v-row>
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">Biaya Pengiriman</div>
                </v-col>
                <v-col cols="12" sm="8">
                  <!-- {{ pembelian }} -->
                  <div
                    class="d-flex pa-3 grey lighten-2 black--text font-weight-medium"
                  >{{ pembelian.price_shipping | toRupiah }}</div>
                </v-col>
              </v-row>
              <v-row v-show="(pembelian.insurance_status==true)?true:false">
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">Biaya Asuransi</div>
                </v-col>
                <v-col cols="12" sm="8">
                  <!-- {{ pembelian }} -->
                  <div
                    class="d-flex pa-3 grey lighten-2 black--text font-weight-medium"
                  >{{ pembelian.insurance_price | toRupiah }}</div>
                </v-col>
              </v-row>

              <v-row v-if="pembelian.courier_code == 'pickup'">
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">
                    Tanggal Pengambilan
                    <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
                  </div>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-menu
                    ref="menuDate"
                    v-model="menuDate"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pickupDateText"
                        :rules="dateRules"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details="auto"
                        outlined
                        clearable
                        densed
                        class="datePickerSmall"
                        placeholder="Tanggal"
                        @click:clear="clearDate"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="today" v-model="pickupDate" no-title></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div
                    class="d-block text-subtitle-2 font-weight-bold black--text"
                  >Catatan untuk Supplier</div>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-textarea
                    v-model="pembelian.notes"
                    outlined
                    small
                    dense
                    no-resize
                    rows="4"
                    counter="200"
                    maxlength="200"
                    placeholder="Catatan"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" :class="{ 'py-0': isMobile }">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">Total Transaksi</div>
                </v-col>
                <v-col cols="12" sm="8">
                  <div
                    class="d-flex justify-end py-4 font-weight-bold green--text"
                  >{{(grandTotalTransaction) | toRupiah}}</div>
                </v-col>
              </v-row>
            </template>
            <div
              v-if="notMinimumTransaction"
              class="d-flex py-4"
              :class="{ 'flex-column': isMobile }"
            >
              <v-alert dense color="error" outlined class="white--text mb-5 orange lighten-5">
                <div class="text-subtitle-2">
                  Total Pembelian belum memenuhi syarat minimal transaksi
                  senilai
                  {{
                  dataSupplier.product_supplier_transaction_minimum | toRupiah
                  }}
                </div>
              </v-alert>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions :class="isMobile ? 'px-5 mx-5' : 'mt-5'">
          <v-spacer v-if="!isMobile"></v-spacer>
          <v-card-text>
            <v-row class="justify-end">
              <hr />
              <v-btn
                outlined
                @click="dialogCart = false"
                class="px-5 mr-2"
                v-if="!isMobile"
                :class="{ 'v-btn--block mb-4': isMobile }"
              >Tutup</v-btn>
              <template v-if="pembelian.items.length !== 0">
                <v-btn
                  color="red"
                  dark
                  class="px-5 mr-2"
                  outlined
                  :disabled="pembelian.items.length === 0"
                  :loading="loadingBelanja"
                  @click="dialogCancelPO = true"
                  v-if="!isMobile"
                >
                  <span class="text-subtitle-2 text-capitalize font-weight-bold">Batalkan Pembelian</span>
                </v-btn>
                <v-btn
                  color="green"
                  dark
                  class="px-5"
                  width="150"
                  :disabled="pembelian.items.length === 0"
                  :loading="loadingBelanja"
                  :class="{ 'v-btn--block mb-4': isMobile }"
                  @click="checkoutPO"
                >
                  <span class="text-subtitle-2 text-capitalize font-weight-bold">Checkout</span>
                </v-btn>
                <v-btn
                  color="red"
                  dark
                  class="px-5"
                  outlined
                  block
                  :disabled="pembelian.items.length === 0"
                  :loading="loadingBelanja"
                  @click="dialogCancelPO = true"
                  v-if="isMobile"
                >
                  <span class="text-subtitle-2 text-capitalize font-weight-bold">Batalkan Pembelian</span>
                </v-btn>
              </template>
              <v-btn
                outlined
                @click="dialogCart = false"
                class="px-5 mt-3"
                v-if="isMobile"
                :class="{ 'v-btn--block mb-4': isMobile }"
              >Tutup</v-btn>
            </v-row>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRemoveProduct" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">Hapus Produk</v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <v-row>
            <v-col cols="12">
              <div
                class="text-subtitle-1 mb-3"
              >Apakah yakin akan menghapus produk ini dari daftar pembelian ?</div>
              <v-card outlined elevation="0" v-if="selectedProduk">
                <div class="d-flex flex-row align-center py-3">
                  <v-img
                    width="80"
                    max-width="80"
                    class="mr-4"
                    :src="
                      selectedProduk.product.product_image[0]
                        ? selectedProduk.product.product_image[0]
                        : '/assets/product/default.png'
                    "
                  ></v-img>
                  <div class="d-flex flex-column">
                    <router-link
                      :to="'/seller/product/'"
                      class="font-weight-bold no-line mb-2"
                    >{{ selectedProduk.product.product_name }}</router-link>
                    <div class="text-caption">
                      Harga :
                      {{ selectedProduk.product.product_price | toRupiah }}
                    </div>
                    <div class="text-caption">Jumlah : {{ selectedProduk.product_qty }}</div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="(selectedProduk = null), (dialogRemoveProduct = false);"
              :loading="loadingProcess"
              class="my-2 px-5 text-capitalize"
            >Batal</v-btn>
            <v-btn
              color="red"
              outlined
              @click="removeItemAction"
              :loading="loadingProcess"
              class="my-2 px-5 ml-2 text-capitalize white--text"
            >Hapus</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCancelPO" persistent max-width="500">
      <v-card>
        <v-card-title
          class="text-h6 text-capitalize red--text darken-4 justify-center"
        >Pembatalan Transaksi</v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col cols="12">
              <div
                class="text-subtitle-1 mb-3"
              >Apakah yakin akan membatalkan transaksi pembelian ini ?</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-3">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingBelanja"
              :disabled="pembelian.items.length === 0"
              @click="dialogCancelPO = false"
            >Tidak</v-btn>
            <v-btn
              color="red"
              outlined
              :loading="loadingBelanja"
              :disabled="pembelian.items.length === 0"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="clearPO"
            >Ya, Batalkan</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { midtransURL } from "@/config";
import { midtransKey } from "@/config";

import cardListVue from "./components/cardList.vue";
import SearchDialog from "./components/supplierSection.vue";
import modalAddAddress from "./components/ModalAddAddress";
import modalSelectAddress from "./components/ModalSelectAddress";

// import apiAuth from "@/helpers/auth";
export default {
  props: ["allowedStatus"],
  components: {
    "card-list": cardListVue,
    SearchDialog,
    modalAddAddress,
    modalSelectAddress
  },
  data() {
    return {
      isVolume: false,
      selectedAddress: null,
      imgUpload: {},
      listCourierMarketplace: [],
      dropship: {
        is_dropship: false,
        is_dropship_marketplace: false,
        dropship_store_name: "",
        dropship_store_phone: "",
        dropship_marketplace_name: "",
        dropship_marketplace_invoice: "",
        dropship_marketplace_resi: "",
        dropship_marketplace_file_shipping_label: ""
      },
      notMinimumTransaction: false,
      notSameSupplier: false,
      menuDate: false,
      pickupDate: "",
      pickupDateText: "",
      loading: false,
      loadingBelanja: false,
      loadingProduct: false,
      loadingProcess: false,
      dialogAddProduct: false,
      dialogCart: false,
      dialogRemoveProduct: false,
      dialogCancelPO: false,
      isMobile: false,
      grandTotalTransaction: 0,
      pembelian: {
        items: [],
        notes: "",
        courier_id: "",
        courier_group: "",
        courier_code: "",
        courier_service: "",
        price_shipping: 0,
        insurance_status: false,
        insurance_price: 0,
        shippingSelected: null,
        is_drop:false,
        is_cod:false,
      },
      courierCodeRules: [v => !!v || "Kurir Pengiriman tidak boleh kosong"],
      dateRules: [v => !!v || "Tanggal Pengambilan tidak boleh kosong"],
      qtyRules: [
        v => !!v || "Jumlah belanja tidak boleh kosong",
        v => !isNaN(parseInt(v)) || "Jumlah belanja mohon diisi dengan angka",
        v => parseInt(v) >= 1 || "Jumlah belanja diisi minimal 1"
      ],
      selectedProduk: null,
      existProduct: false,
      produkForm: {
        supplier: {
          product_supplier_id: "",
          product_supplier_name: "",
          product_supplier_transaction_minimum: "",
          product_supplier_image: "",
          product_supplier_is_active: ""
        },
        product: "",
        product_qty: 1,
        product_subtot: 0,
        product_weight_subtot: 0
      },
      grandTotal: 0,
      grandWeightTotal: 0,
      productIdParams: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_buyer_user_name"
      },
      productNameParams: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_midtrans_invoice"
      },
      productQtyParams: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_status_created_datetime"
      }
    };
  },

  computed: {
    ...mapState("addressKiriminaja", ["addressData"]),
    ...mapState("cart", ["saldoCoinGen", "saldoDepositReseller"]),
    ...mapState("pembelianSeller", [
      "resellerTypeValue",
      "pembelianData",
      "pembelianPagination",
      "listProduk",
      "listSupplier",
      "shippingFees",
      "shippingFeesInstant",
      "response",
      "responseError"
    ]),
    ...mapState("storeSeller", ["detailStore"]),
    dataSupplier: function() {
      return this.produkForm.supplier;
    },
    dataBeli: function() {
      return this.pembelian;
    },
    shippingOption: {
      get() {
        let shipping = [];
        // console.log("this.shippingFees", this.shippingFees);
        if (this.shippingFees != null) {
          if (this.shippingFees.results.length) {
            this.shippingFees.results.forEach((item, idx) => {
              let itemDetail = {
                id: item.service,
                code: item.service + "_" + item.service_type,
                cost: item.cost,
                etd: item.etd,
                group: item.group,
                description: item.group,
                name: item.service_name,
                service: item.service_type,
                raw: item,
                service: item.service_type,
                drop: item.drop,
                cod: item.cod
              };
              shipping.push(itemDetail);
            });
          }
        }
        if (this.shippingFeesInstant != null) {
          if (this.shippingFeesInstant.results.length) {
            this.shippingFeesInstant.results.forEach((item, idx) => {
              let itemDetail = {
                id: item.service,
                code: item.service + "_" + item.service_type,
                cost: item.cost,
                etd: item.etd,
                group: item.group,
                description: item.group,
                name: item.service_name,
                service: item.service_type,
                raw: item,
                drop: false,
                cod: false
              };
              shipping.push(itemDetail);
            });
          }
        }

        shipping.unshift({
          id: "pickup",
          code: "pickup",
          cost: 0,
          etd: "",
          group: "instant",
          description: "Pengambilan di Toko",
          name: "Ambil di Toko",
          service: "Pickup",
          raw: {},
          drop: false,
          cod: true
        });
        return shipping;
      },
      set(newName) {
        return newName;
      }
    },
    shippingOptionOld() {
      // let shipping = this.shippingFees ? [...this.shippingFees] : [];
      let shipping = [];
      // console.log("this.shippingFees", this.shippingFees);
      if (this.shippingFees != null) {
        if (this.shippingFees.results.length) {
          this.shippingFees.results.forEach((item, idx) => {
            let itemDetail = {
              code: item.service + "_" + item.service_type,
              cost: item.cost,
              etd: item.etd,
              group: item.group,
              description: item.group,
              name: item.service_name,
              service: item.service_type,
              raw: item
            };
            shipping.push(itemDetail);
          });
        }
      }
      if (this.shippingFeesInstant != null) {
        if (this.shippingFeesInstant.results.length) {
          this.shippingFeesInstant.results.forEach((item, idx) => {
            let itemDetail = {
              code: item.service + "_" + item.service_type,
              cost: item.cost,
              etd: item.etd,
              group: item.group,
              description: item.group,
              name: item.service_name,
              service: item.service_type,
              raw: item
            };
            shipping.push(itemDetail);
          });
        }
      }

      shipping.unshift({
        code: "pickup",
        cost: 0,
        etd: "",
        group: "instant",
        description: "Pengambilan di Toko",
        name: "Ambil di Toko",
        service: "Pickup",
        raw: {}
      });
      return shipping;
    }
  },

  async created() {
    this.loading = await true;
    this.getSaldoDepositReseller();
    this.getSaldoCoinGen();
    this.getResellerType();
    this.$store.dispatch("setPageTitle", `Pembelian Produk`);
    await this.getListSupplier({ page: 1, limit: 100 });
    // await this.getListProduk({ page: 1, limit: 100 });
    await this.getStoreDetail();
    await this.getAddress().then(() => {
      this.selectedAddress = this.addressData[0];
      if (this.selectedAddress) {
        // this.getOngkir({
        //   store_id: this.detailCart.cart_store_id,
        //   destination_id: this.selectedAddress.user_address_subdistrict_id
        //     ? this.selectedAddress.user_address_subdistrict_id
        //     : this.selectedAddress.user_address_city_id,
        //   destination_type: this.selectedAddress.user_address_subdistrict_id
        //     ? "subdistrict"
        //     : "city",
        //   weight: this.productTotal.weight_total
        // });
      }
    });
    this.loading = false;
  },

  methods: {
    ...mapActions("addressKiriminaja", ["getAddress", "addAddress"]),
    ...mapActions("cart", ["getSaldoCoinGen", "getSaldoDepositReseller"]),
    ...mapMutations("cart", ["validationError"]),
    ...mapActions("pembelianSeller", [
      "uploadImage",
      "getCourierMarketplace",
      "getResellerType",
      "getListSupplier",
      "getListProduk",
      "getPembelian",
      "getPembelianDetail",
      "getShippingFee",
      "getShippingFeeKiriminajaExpress",
      "getShippingFeeKiriminajaInstant",
      "createPembelianKiriminaja",
      "deletePembelian",
      "bayarPembelian",
      "receivePembelian",
      "saveSnap",
      "notificationPembelian"
    ]),
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapMutations(["makeAlert"]),
    openModalAddAddress() {
      this.$refs.modalAddAddress.modalShow();
      this.responseError.address = "";
    },
    async reloadOngkir(destination, item_value, weight) {
      this.shippingOption = await [];
      this.loadingProcess = await true;
      this.pembelian.courier_id = "";
      this.pembelian.courier_code = "";
      this.pembelian.courier_service = "";
      this.pembelian.courier_group = "";
      this.pembelian.price_shipping = 0;
      this.pembelian.insurance_price = 0;
      this.pembelian.insurance_status = false;
      this.grandTotalTransaction = this.grandTotal;
      // console.log("this.selectedAddress", this.selectedAddress);
      await this.getShippingFeeKiriminajaExpress({
        destination: this.selectedAddress.user_address_subdistrict_id,
        item_value: this.grandTotal,
        weight: this.grandWeightTotal
      }).catch(() => {});
      if (
        this.selectedAddress.user_address_longitude != "" &&
        this.selectedAddress.user_address_latitude != ""
      ) {
        let latitude = parseFloat(this.selectedAddress.user_address_latitude);
        let longitude = parseFloat(this.selectedAddress.user_address_longitude);

        await this.getShippingFeeKiriminajaInstant({
          destination_lat: latitude,
          destination_long: longitude,
          destination_address: this.selectedAddress.user_address_detail,
          item_value: this.grandTotal,
          weight: this.grandWeightTotal
        }).catch(() => {
          console.log("error instant");
        });
      }
      this.loadingProcess = await false;
    },
    async selectAddress(address) {
      this.selectedAddress = address;
      if (this.selectedAddress != null) {
        // await this.getShippingFeeKiriminajaExpress({
        //   destination: this.selectedAddress.user_address_subdistrict_id,
        //   item_value: this.grandTotal,
        //   weight: this.grandWeightTotal
        // });
        this.reloadOngkir(
          this.selectedAddress.user_address_subdistrict_id,
          this.grandTotal,
          this.grandWeightTotal
        );
      }
      // this.getOngkir({
      //   store_id: this.detailCart.cart_store_id,
      //   destination_id: this.selectedAddress.user_address_subdistrict_id
      //     ? this.selectedAddress.user_address_subdistrict_id
      //     : this.selectedAddress.user_address_city_id,
      //   destination_type: this.selectedAddress.user_address_subdistrict_id
      //     ? "subdistrict"
      //     : "city",
      //   weight: this.productTotal.weight_total
      // }).then(cour => {
      //   this.selectedCour = cour[0] ? cour[0] : {};
      // });
    },
    // async calculateOngkir() {},
    async saveAddress(address) {
      this.addAddress(address).then(() => {
        this.getAddress().then(async () => {
          // console.log("this.addressData", this.addressData);
          this.selectedAddress = this.addressData[this.addressData.length - 1];
          // console.log("this.selectedAddress", this.selectedAddress);
          if (this.selectedAddress != null) {
            // await this.getShippingFeeKiriminajaExpress({
            //   destination: this.selectedAddress.user_address_subdistrict_id,
            //   item_value: this.grandTotal,
            //   weight: this.grandWeightTotal
            // });
            this.reloadOngkir(
              this.selectedAddress.user_address_subdistrict_id,
              this.grandTotal,
              this.grandWeightTotal
            );
          }
          // this.getOngkir({
          //   store_id: this.detailCart.cart_store_id,
          //   destination_id: this.selectedAddress.user_address_subdistrict_id
          //     ? this.selectedAddress.user_address_subdistrict_id
          //     : this.selectedAddress.user_address_city_id,
          //   destination_type: this.selectedAddress.user_address_subdistrict_id
          //     ? "subdistrict"
          //     : "city",
          //   weight: this.productTotal.weight_total
          // }).then(cour => {
          //   this.selectedCour = cour[0] ? cour[0] : {};
          // });
        });
      });
    },
    addressText(value) {
      var data = [];
      if (value.user_address_detail) data.push(value.user_address_detail);
      if (value.user_address_subdistrict_name)
        data.push(value.user_address_subdistrict_name);
      if (value.user_address_city_name) data.push(value.user_address_city_name);
      if (value.user_address_province_name)
        data.push(value.user_address_province_name);
      return data.join(", ");
    },
    openModalAddress() {
      this.$refs.modalAddress.modalShow(this.selectedAddress);
      this.responseError.address = "";
    },
    async openUpload() {
      const input = await document.getElementById("inputImage");
      input.click();
    },
    showConfirmAdd(item) {
      if (this.produkForm.supplier.product_supplier_id == "") return;
      this.produkForm.product = { ...item };
      this.dialogAddProduct = true;
      this.cekExistingProduct();
    },
    handleFileUpload(event) {
      this.dropship.dropship_marketplace_file_shipping_label = "";
      this.loadingProcess = true;
      let formData = new FormData();
      formData.append("image", event);
      this.uploadImage(formData)
        .then(resImg => {
          // console.log("resImg", resImg)
          this.dropship.dropship_marketplace_file_shipping_label =
            resImg.data.file;
          this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          this.loadingProcess = false;
        })
        .catch(() => {
          this.loadingProcess = false;
        });
    },
    async getProduct() {
      // console.log("supplier", this.produkForm.supplier);
      // let filter = {
      //   product_supplier_id: this.produkForm.supplier.product_supplier_id
      // };
      // console.log("filter", filter);
      this.produkForm.product = await "";
      this.loadingProduct = true;
      await this.getListProduk({
        page: 1,
        limit: 100000,
        supplier_id: this.produkForm.supplier.product_supplier_id
      })
        .then(res => {
          console.log(res);
          this.loadingProduct = false;
        })
        .catch(() => {
          this.loadingProduct = false;
        });
    },
    recalculateShipping() {
      if (
        this.dropship.is_dropship == true &&
        this.dropship.is_dropship_marketplace == true
      ) {
        this.pembelian.courier_id = "";
        this.pembelian.courier_code = "-";
        this.pembelian.courier_group = "";
        this.pembelian.courier_service = "";
        this.pembelian.price_shipping = 0;
        this.pembelian.insurance_price = 0;
        this.pembelian.insurance_status = false;
      }
      if (this.dropship.dropship_marketplace_name != "") {
        this.pembelian.courier_code = this.dropship.dropship_marketplace_name.courier_code;
      }
      // console.log("this.dropsh", this.dropship.dropship_marketplace_name)
    },
    async getListCourier() {
      this.listCourierMarketplace = [];
      if (this.dropship.is_dropship == false) {
        this.dropship.is_dropship_marketplace = false;
      }
      if (this.dropship.is_dropship == true) {
        this.getCourierMarketplace().then(response => {
          this.listCourierMarketplace = response;
          // console.log("ressss", this.listCourierMarketplace)
        });
      }
    },
    clearDate() {
      this.pickupDate = "";
    },
    clearFormProduk() {
      this.existProduct = false;
      this.dialogAddProduct = false;
    },

    async cekExistingProduct() {
      this.notSameSupplier = await false;
      let existItem = await this.pembelian.items.findIndex(
        x => x.product.product_id === this.produkForm.product.product_id
      );
      this.produkForm.product_qty = 1;

      if (existItem >= 0) {
        this.produkForm.product_qty = await this.pembelian.items[existItem]
          .product_qty;
        this.produkForm.product_subtot =
          (await this.produkForm.product_qty) *
          this.produkForm.product.product_price;
        this.produkForm.product_weight_subtot =
          (await this.produkForm.product.product_weight) *
          this.produkForm.product_qty;
        //hitung berat volume
        let weightVolume =
          (await (this.produkForm.product.product_length *
            this.produkForm.product.product_width *
            this.produkForm.product.product_height)) / 6;
        if (this.produkForm.product_weight_subtot < weightVolume) {
          this.produkForm.product_weight_subtot = await weightVolume;
        }
        this.existProduct = true;
        // this.getShippingFee({
        //   store_id: 1,
        //   weight: this.produkForm.product_weight_subtot
        // });
        if (this.selectedAddress != null) {
          await this.reloadOngkir(
            this.selectedAddress.user_address_subdistrict_id,
            this.produkForm.product_subtot,
            this.produkForm.product_weight_subtot
          );
        }
      } else this.existProduct = false;
    },
    calculateDiscount(resellerTypeValue, productArr) {
      let discountValue = 0;
      let discountPercent = 0;
      let product_price_gross = productArr.product_price;
      if (typeof productArr.product_price_gross != "undefined") {
        product_price_gross = productArr.product_price_gross;
      }
      let product_price = product_price_gross;
      productArr.discount_percent_reseller_starter =
        productArr.discount_percent_reseller_starter * 1;
      productArr.discount_percent_reseller_bisnis =
        productArr.discount_percent_reseller_bisnis * 1;
      productArr.discount_percent_reseller_enterprise =
        productArr.discount_percent_reseller_enterprise * 1;
      switch (resellerTypeValue) {
        case "enterprise":
          discountValue =
            product_price_gross *
            (productArr.discount_percent_reseller_enterprise / 100);
          discountPercent = productArr.discount_percent_reseller_enterprise;
          product_price = product_price_gross - discountValue;
          break;
        case "bisnis":
          discountValue =
            product_price_gross *
            (productArr.discount_percent_reseller_bisnis / 100);
          discountPercent = productArr.discount_percent_reseller_bisnis;
          product_price = product_price_gross - discountValue;
          break;
        case "starter":
          discountValue =
            product_price_gross *
            (productArr.discount_percent_reseller_starter / 100);
          discountPercent = productArr.discount_percent_reseller_starter;
          product_price = product_price_gross - discountValue;
          break;
      }

      return {
        discount_value: discountValue,
        discount_percent: discountPercent,
        product_price: product_price,
        product_price_gross: product_price_gross
      };
    },
    async addToCart() {
      if (this.$refs.formAddProduk.validate()) {
        this.loadingProcess = await true;
        let discountArr = this.calculateDiscount(
          this.resellerTypeValue,
          this.produkForm.product
        );

        this.produkForm.product.product_price_gross =
          discountArr.product_price_gross;
        this.produkForm.product.product_price = discountArr.product_price;
        this.produkForm.product.discount_percent = discountArr.discount_percent;
        this.produkForm.product.discount_value = discountArr.discount_value;
        this.produkForm.product_subtot =
          (await this.produkForm.product_qty) *
          this.produkForm.product.product_price;
        this.produkForm.product_weight_subtot =
          (await this.produkForm.product_qty) *
          this.produkForm.product.product_weight;

        //hitung berat volume
        let weightVolume =
          (await (this.produkForm.product.product_length *
            this.produkForm.product.product_width *
            this.produkForm.product.product_height *
            this.produkForm.product_qty)) / 6;
        if (this.produkForm.product_weight_subtot < weightVolume) {
          this.produkForm.product_weight_subtot = await weightVolume;
        }

        let existItem = await this.pembelian.items.findIndex(
          x => x.product.product_id === this.produkForm.product.product_id
        );

        if (existItem < 0) {
          this.produkForm.product_supplier_id = await this.produkForm.supplier
            .product_supplier_id;
          this.produkForm.product_supplier_name = await this.produkForm.supplier
            .product_supplier_name;
          await this.pembelian.items.push(this.produkForm);
        } else {
          this.produkForm.product_supplier_id = await this.produkForm.supplier
            .product_supplier_id;
          this.produkForm.product_supplier_name = await this.produkForm.supplier
            .product_supplier_name;
          this.pembelian.items[existItem] = await this.produkForm;
        }

        await this.countTotal();
        this.pembelian.courier_id = "";
        this.pembelian.courier_code = "";
        this.pembelian.courier_group = "";
        this.pembelian.courier_service = "";
        this.pembelian.price_shipping = 0;
        this.pembelian.insurance_price = 0;
        this.pembelian.insurance_status = false;
        this.grandTotalTransaction = 0;

        // if (this.selectedAddress != null) {
        //   await this.reloadOngkir(
        //     this.selectedAddress.user_address_subdistrict_id,
        //     this.produkForm.product_subtot,
        //     this.produkForm.product_weight_subtot
        //   );
        // }

        this.dialogAddProduct = await false;
        this.produkForm = await {
          supplier: this.dataSupplier,
          product: "",
          product_qty: 1,
          is_volume: false
        };
        this.existProduct = await false;
        this.loadingProcess = false;
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        });
      }
    },

    async removeItem(idx) {
      this.selectedProduk = await this.pembelian.items[idx];
      this.dialogRemoveProduct = true;
    },

    async removeItemAction() {
      this.loadingProcess = await true;
      if (this.selectedProduk) {
        let existItem = await this.pembelian.items.findIndex(
          x => x.product.product_id === this.selectedProduk.product.product_id
        );
        if (existItem >= 0) await this.pembelian.items.splice(existItem, 1);
      }

      await this.countTotal();
      this.pembelian.courier_id = await "";
      this.pembelian.courier_code = await "";
      this.pembelian.courier_group = await "";
      this.pembelian.courier_service = await "";
      this.pembelian.price_shipping = await 0;
      this.pembelian.insurance_price = await 0;
      this.pembelian.insurance_status = await false;
      this.grandTotalTransaction = await 0;

      // await this.getShippingFee({
      //   store_id: this.detailStore.store_id,
      //   weight: this.grandWeightTotal
      // });
      if (this.selectedAddress != null) {
        // await this.getShippingFeeKiriminajaExpress({
        //   destination: this.selectedAddress.user_address_subdistrict_id,
        //   item_value: this.grandTotal,
        //   weight: this.grandWeightTotal
        // });
        await this.reloadOngkir(
          this.selectedAddress.user_address_subdistrict_id,
          this.grandTotal,
          this.grandWeightTotal
        );
      }
      this.selectedProduk = await null;
      this.loadingProcess = await false;
      this.dialogRemoveProduct = false;
    },
    async cartModalCheckOngkir() {
      this.dialogCart = true;
      if (this.selectedAddress != null) {
        await this.reloadOngkir(
          this.selectedAddress.user_address_subdistrict_id,
          this.grandTotal,
          this.grandWeightTotal
        );
      }
    },
    countTotal() {
      this.grandTotal = this.pembelian.items.reduce(
        (accumulator, current) => accumulator + current.product_subtot,
        0
      );
      this.grandWeightTotal = this.pembelian.items.reduce(
        (accumulator, current) => accumulator + current.product_weight_subtot,
        0
      );
    },

    clearPO() {
      this.selectedProduk = null;
      this.grandTotal = 0;
      this.grandWeightTotal = 0;
      this.existProduct = false;
      this.pembelian.items = [];
      this.pembelian.notes = "";
      this.pembelian.courier_id = "";
      this.pembelian.courier_code = "";
      this.pembelian.courier_service = "";
      this.pembelian.courier_group = "";
      this.pembelian.price_shipping = 0;
      this.pembelian.insurance_price = 0;
      this.pembelian.insurance_status = false;
      this.grandTotalTransaction = 0;

      this.produkForm = {
        supplier: {
          product_supplier_id: "",
          product_supplier_name: "",
          product_supplier_transaction_minimum: "",
          product_supplier_image: "",
          product_supplier_is_active: ""
        },
        product: "",
        product_qty: 1,
        is_volume: false
      };
      this.existProduct = false;
      this.dialogCancelPO = false;
    },

    async changeCourier(item) {
      this.grandTotalTransaction = await 0;

      this.pembelian.shippingSelected = await null;
      this.pembelian.courier_id = await item.id;
      this.pembelian.courier_code = await item.code;
      this.pembelian.courier_service = await item.service;
      this.pembelian.courier_group = await item.group;
      this.pembelian.price_shipping = await item.cost;
      let result = await this.shippingOption.filter(obj => {
        return obj.code === item.code;
      });
      if (result.length) {
        this.pembelian.shippingSelected = await result[0];
      }
      await this.calculateInsurance();
    },
    calculateInsurance(checkForce = true) {
      this.pembelian.insurance_price = 0;
      if (this.pembelian.shippingSelected != null) {
        if (this.pembelian.shippingSelected.code != "pickup") {
          // console.log(
          //   "this.pembelian.shippingSelected.raw.force_insurance",
          //   this.pembelian.shippingSelected.raw.force_insurance
          // );
          if (
            checkForce == true &&
            this.pembelian.shippingSelected.raw.force_insurance == true
          ) {
            this.pembelian.insurance_status = true;
          }
        } else {
          this.pembelian.insurance_status = false;
        }

        if (this.pembelian.insurance_status == true) {
          let gt = this.grandTotal * 1;
          let percentInsurance =
            this.pembelian.shippingSelected.raw.setting.insurance_fee * 1;
          let insuranceAddCost =
            this.pembelian.shippingSelected.raw.setting.insurance_add_cost * 1;
          let insuranceValue = Math.ceil(
            gt * percentInsurance + insuranceAddCost
          );
          insuranceValue = Math.ceil(insuranceValue / 100) * 100;
          this.pembelian.insurance_price = insuranceValue;
        }
      }
      this.grandTotalTransaction =
        this.grandTotal * 1 +
        this.pembelian.price_shipping * 1 +
        this.pembelian.insurance_price * 1;
    },
    checkout() {
      if (this.validateShipping()) {
        this.getInvoice();
      }
    },
    validateShipping() {
      if (this.selectedCour == "pick_up") {
        if (!this.pickup_date) {
          this.validationError({
            pick_up_date: "Tentukan jadwal pengambilan produk"
          });
        } else {
          return true;
        }
      } else {
        if (!this.selectedAddress) {
          this.validationError({
            address: "Pilih Alamat terlebih dahulu"
          });
        } else if (!this.selectedCour) {
          this.validationError({
            courier: "Pilih Kurir untuk melanjutkan"
          });
        } else {
          return true;
        }
      }
    },
    async checkoutPO() {
      if (this.$refs.formPO.validate()) {
        let is_dropship = this.dropship.is_dropship == true ? 1 : 0;
        let is_dropship_marketplace =
          this.dropship.is_dropship_marketplace == true ? 1 : 0;

        this.loadingBelanja = await true;
        let params = await {
          is_dropship: is_dropship,
          is_dropship_marketplace: is_dropship_marketplace,
          dropship_store_name: this.dropship.dropship_store_name,
          dropship_store_phone: this.dropship.dropship_store_phone,
          dropship_marketplace_name: this.dropship.dropship_marketplace_name,
          dropship_marketplace_invoice: this.dropship
            .dropship_marketplace_invoice,
          dropship_marketplace_resi: this.dropship.dropship_marketplace_resi,
          dropship_marketplace_file_shipping_label: this.dropship
            .dropship_marketplace_file_shipping_label,
          supplier_id: this.produkForm.supplier.product_supplier_id,
          note: this.pembelian.notes,
          courier_id: this.pembelian.courier_id,
          courier_code: this.pembelian.courier_code,
          courier_group: this.pembelian.courier_group,
          courier_service: this.pembelian.courier_service,
          courier_id: this.pembelian.courier_id,
          is_cod: this.pembelian.shippingSelected.cod,
          is_drop: this.pembelian.shippingSelected.drop,
          pick_up_date: this.pickupDate,
          price_shipping: this.pembelian.price_shipping,
          insurance_price: this.pembelian.insurance_price,
          insurance_status: this.pembelian.insurance_status,
          user_address_id: this.selectedAddress.user_address_id,
          product: []
        };
        if (this.pembelian.items) {
          for (let i = 0; i < this.pembelian.items.length; i++) {
            params.product.push({
              product_id: this.pembelian.items[i].product.product_id,
              product_name: this.pembelian.items[i].product.product_name,
              quantity: this.pembelian.items[i].product_qty,
              product_category_id: this.pembelian.items[i].product
                .product_category_id,
              product_supplier_id: this.pembelian.items[i].product_supplier_id,
              product_price: this.pembelian.items[i].product.product_price,
              product_price_gross: this.pembelian.items[i].product
                .product_price_gross,
              discount_percent: this.pembelian.items[i].product
                .discount_percent,
              discount_value: this.pembelian.items[i].product.discount_value
            });
          }
        }
        // 'po_detail_product_price_gross' => isset($_product['product_price_gross']) ? $_product['product_price_gross'] : $_product['product_price'],
        // 		'po_detail_product_discount_percent' => isset($_product['discount_percent']) ? $_product['discount_percent'] : 0,
        // 		'po_detail_product_discount_nominal' => isset($_product['discount_value']) ? $_product['discount_value'] : 0,
        // console.log("itemss",this.pembelian.items)
        this.notMinimumTransaction = false;
        // return false;
        // let grandTotalNum = this.grandTotal * 1;
        // let minimalTransaksiNum =
        //   this.dataSupplier.product_supplier_transaction_minimum * 1;
        // if (grandTotalNum < 1 || grandTotalNum < minimalTransaksiNum) {
        //   // this.notMinimumTransaction = await true; //dimatikan karna tidak jadi digunakan
        //   this.loadingBelanja = await false;

        //   return false;
        // }

        this.createPembelianKiriminaja(params)
          .then(async data => {
            let router = this.$router;
            let delParam = {
              po_code: data.data.data.order_id
            };
            this.clearPO();
            // let removecart = this.clearPO;
            // let deletePembelian = this.deletePembelian;
            // let notificationPembelian = this.notificationPembelian;
            this.makeAlert({
              code: "success",
              type: "success",
              message: "Data belanja Reseller berhasil disimpan.",
              show: true
            });
            // that.clearPO();
            this.loadingBelanja = false;
            this.$router.push({
              name: "seller-pembelian"
            });
            // let saveSnap = await this.saveSnap;
            // // console.log("data:snap", data);
            // // console.log("data:token", data.data.data.token);
            // // console.log("snap:::", snap);
            // var that = this;
            // snap.pay(data.data.data.token, {
            //   onSuccess: function (result) {
            //     console.log("success", result);
            //     notificationPembelian(result);
            //     saveSnap(result).then(() => {
            //       removecart();
            //       // window.open(result.pdf_url);
            //       // window.location = result.finish_redirect_url;
            //       console.log("success:::", result.pdf_url);
            //       console.log(
            //         "result.finish_redirect_url:::",
            //         result.finish_redirect_url
            //       );

            //       that.makeAlert({
            //         code: "success",
            //         type: "success",
            //         message: this.response.message,
            //         show: true
            //       });
            //       // that.clearPO();
            //       that.loadingBelanja = false;
            //       that.$router.push({
            //         name: "seller-pembelian"
            //       });
            //     });
            //   },
            //   onPending: function (result) {
            //     console.log("pending", result);
            //     notificationPembelian(result);
            //     saveSnap(result).then(() => {
            //       removecart();
            //       console.log("pennding:::", result.pdf_url);
            //       console.log(
            //         "result.finish_redirect_url:::",
            //         result.finish_redirect_url
            //       );

            //       that.loadingBelanja = false;
            //       that.$router.push({
            //         name: "seller-pembelian"
            //       });
            //     });
            //   },
            //   onError: function (result) {
            //     that.loadingBelanja = false;
            //     console.log("error", result);
            //     deletePembelian(delParam);
            //     saveSnap(result);
            //     router.push({
            //       name: "seller-pembelian"
            //     });
            //   },
            //   onClose: function (result) {
            //     deletePembelian(delParam);
            //     that.loadingBelanja = false;
            //     console.log("cancel", data, result);
            //     console.log(
            //       "customer closed the popup without finishing the payment"
            //     );
            //   }
            // });
          })
          .catch(response => {
            // console.log("error",response)
            this.loadingBelanja = false;
          });
      }
    },

    async addQty(produk) {
      await produk.product_qty++;
      await this.changeQty(produk);
    },

    async minsQty(produk) {
      await produk.product_qty--;
      await this.changeQty(produk);
    },

    async changeQty(produk) {
      console.log("pkkkk");
      produk.product_subtot =
        (await produk.product_qty) * produk.product.product_price;
      produk.product_weight_subtot =
        (await produk.product_qty) * produk.product.product_weight;
      //hitung berat volume
      let weightVolume =
        (await (parseFloat(produk.product.product_length) *
          parseFloat(produk.product.product_width) *
          parseFloat(produk.product.product_height) *
          parseFloat(produk.product_qty))) / 6;
      // console.log("produk.product_length",produk.product_length)
      // console.log("produk.product_width",produk.product_width)
      // console.log("produk.product_height",produk.product_height)
      // console.log("produk",produk)
      // console.log(
      //   "weightVolume",
      //   weightVolume,
      //   "produk.product_weight_subtot",
      //   produk.product_weight_subtot
      // );
      if (produk.product_weight_subtot < weightVolume) {
        produk.product_weight_subtot = await weightVolume;
      }
      await this.countTotal();
      this.pembelian.courier_code = await "";
      this.pembelian.courier_service = await "";
      this.pembelian.price_shipping = await 0;
      this.pembelian.insurance_status = await false;
      this.pembelian.insurance_price = await 0;
      this.grandTotalTransaction = await 0;
      // this.getShippingFee({
      //   store_id: this.detailStore.store_id,
      //   weight: this.grandWeightTotal
      // });
      if (this.selectedAddress != null) {
        // await this.getShippingFeeKiriminajaExpress({
        //   destination: this.selectedAddress.user_address_subdistrict_id,
        //   item_value: this.grandTotal,
        //   weight: this.grandWeightTotal
        // });
        await this.reloadOngkir(
          this.selectedAddress.user_address_subdistrict_id,
          this.grandTotal,
          this.grandWeightTotal
        );
      }
      this.recalculateShipping();
    },

    backToList() {
      this.$router.push({
        name: "seller-pembelian"
      });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },
  filters: {
    uppercase: function(v) {
      return v.toUpperCase();
    }
  },
  watch: {
    "produkForm.product_supplier_id": {
      handler: function(nv) {
        if (nv == "") {
          this.setListProduk({ data: [] });
        }
      },
      deep: true,
      immediate: true
    },
    pickupDate(val) {
      if (val) {
        this.pickupDateText = this.$options.filters.tanggal(this.pickupDate);
      } else {
        this.pickupDateText = "";
      }
    }
  },
  mounted() {
    let midtrans = document.createElement("script");
    midtrans.setAttribute("src", midtransURL);
    midtrans.setAttribute("data-client-key", midtransKey);
    document.head.appendChild(midtrans);
  }
};
</script>

<style lang="scss" scoped>
.v-spacer {
  width: 1px;
  height: 30px;
  background: transparent;
  display: block;
  position: relative;
  margin: 0 auto;
  border-left: 3px dotted #ccc;
}
</style>
